import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';

import { TextField } from 'common/formFields';


const PasswordField = (props) => {
  const { className, ...rest } = props;

  return (
    <TextField
      {...rest}
      type="password"
      className={classnames('password-field', { [className]: className })}
    />
  );
};

PasswordField.propTypes = {
  className: PropTypes.string,
};


export default PasswordField;
